import { create } from 'zustand';
import type { CatalogoInversor, CatalogoModulo, Concessionaria, ArquivoFormulario } from '@engenharia/shared';
import { listarInversores, listarModulos, listarConcessionarias } from '../api/catalogo';

interface FormStore {
  inversores: CatalogoInversor[];
  modulos: CatalogoModulo[];
  concessionarias: Concessionaria[];
  arquivos: ArquivoFormulario[];
  loaded: boolean;

  loadCatalogos: () => Promise<void>;
  setArquivos: (arquivos: ArquivoFormulario[]) => void;
  addArquivo: (arquivo: ArquivoFormulario) => void;
  removeArquivo: (id: number) => void;
}

export const useFormStore = create<FormStore>((set, get) => ({
  inversores: [],
  modulos: [],
  concessionarias: [],
  arquivos: [],
  loaded: false,

  loadCatalogos: async () => {
    if (get().loaded) return;
    try {
      const [inv, mod, conc] = await Promise.all([
        listarInversores(),
        listarModulos(),
        listarConcessionarias(),
      ]);
      set({ inversores: inv, modulos: mod, concessionarias: conc, loaded: true });
    } catch (err) {
      console.error('Failed to load catalogs:', err);
    }
  },

  setArquivos: (arquivos) => set({ arquivos }),
  addArquivo: (arquivo) => set((s) => ({ arquivos: [...s.arquivos, arquivo] })),
  removeArquivo: (id) => set((s) => ({ arquivos: s.arquivos.filter((a) => a.id !== id) })),
}));
